<template>
  <div class="do-dropdown" :class="{'do-dropdown--open': isOpen}" v-on-clickaway="onClickAway">
    <button
      class="do-dropdown__toggler do-bttn do-bttn--submit"
      :class="{'do-bttn--submit--disabled': isDisabled}"
      :disabled="isDisabled"
      @click="toggleOpen"
    >
      Tilføj stillingskategori <span class="icon-arrow-down5"></span>
    </button>

    <!-- Dropdown -->
    <transition name="do-dropdown">
      <div class="do-dropdown__dropdown" v-if="isOpen">
        <ul>
          <li
            v-for="employmentType in employmentTypes"
            :key="employmentType.id"
            class="do-dropdown__dropdown__item"
            @click="selectEmploymentType(employmentType)"
          >
            <div class="do-dropdown__dropdown__item__name">
              <span class="icon-users" v-if="employmentType.manual_salary"></span>
              <span class="icon-user" v-else></span>
              {{ employmentType.title }}
            </div>
            <!-- Åbn redigering (stop klik så vi ikke toggler valg) -->
            <div class="icon__bg-circle" @click.stop="openEdit(employmentType)">
              <span class="icon-pencil"></span>
            </div>
          </li>

          <li
            class="do-dropdown__dropdown__item do-dropdown__dropdown__item--add"
            @click="setTemplateModalOpen(true)"
          >
            <div class="btn-trans">
              {{ createNewTitleText }}
            </div>
          </li>
        </ul>
      </div>
    </transition>

    <!-- Create / Edit modal -->
    <DoEmploymentTemplate
      v-if="isTemplateModalOpen"
      :theEditEmploymentTemplate="editTemplate"
      @created="$emit('onTemplateCreated')"
      @updated="$emit('onTemplateUpdated')"
      @deleted="$emit('onTemplateDeleted')"
      @close="closeTemplateModal"
    />
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import DoEmploymentTemplate from './DoEmploymentTemplate.vue'
import eventbus from '../../../eventbus'

export default {
  name: 'DoEmploymentDropdown',
  components: { DoEmploymentTemplate },
  mixins: [clickaway],
  props: {
    selectedEmploymentIds: {
      default: () => []
    },
    employmentTypes: {
      type: Array,
      required: true
      // forventet shape: [{ id, title, manual_salary, ... }]
    },
    value: {
      type: Array,
      default: () => []
      // v-model: Array<String> af valgte titler (beholdt som før)
    },
    canSave: {
      type: Boolean,
      default: false
    },
    isSubmitting: {
      type: Boolean,
      default: false
    },
    createNewTitleText: {
      type: String,
      default: 'Opret ny stillingskategori'
    },
    initiallyOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: this.initiallyOpen,
      isTemplateModalOpen: false,
      editTemplate: null
    }
  },
  computed: {
    isDisabled () {
      return !this.selectedEmploymentIds || this.selectedEmploymentIds.length === 0
    }
  },
  methods: {
    toggleOpen () {
      if (this.isDisabled) return
      if (!this.isOpen) this.$emit('input', [])
      this.isOpen = !this.isOpen
      this.$emit('open-change', this.isOpen)
    },
    onClickAway () {
      if (!this.isOpen) return
      this.$emit('input', [])
      this.isOpen = false
      this.$emit('open-change', this.isOpen)
    },
    isSelected (title) {
      return this.value.findIndex(t => t === title) > -1
    },
    selectEmploymentType (employmentType) {
      if (this.selectedEmploymentIds.length === 0) {
        eventbus.toast = {text: 'Vælg personale først', 'success': false}
        return
      }
      this.$emit('select', employmentType)
      this.isOpen = false
    },
    setTemplateModalOpen (bool) {
      this.isTemplateModalOpen = bool
    },
    openEdit (employmentType) {
      this.editTemplate = employmentType
      this.setTemplateModalOpen(true)
    },
    closeTemplateModal () {
      this.editTemplate = null
      this.setTemplateModalOpen(false)
    }
  }
}
</script>

<style scoped>

.do-dropdown {
  position: relative;
}

.do-dropdown .do-dropdown__toggler {
  transition: transform .25s;
}

.do-dropdown .do-dropdown__toggler:active {
  transform: scale(0.98);
}

.do-dropdown__dropdown {
  position: absolute;
  z-index: 19990;
  top: calc(100% + 0.5rem);
  left: 0;
  width: 300px;
  background-color: #fff;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
  height: auto;
  outline: none;
  text-align: left;
  padding: 0;
  min-width: 100px;
  user-select: none;
  border: 1px solid #6772e5;
  border-radius: 4px
}

.do-dropdown__dropdown ul {
  max-height: 70vh;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.do-dropdown__dropdown li {
  padding: 0.5rem 1rem;
  cursor: pointer;
}

.do-dropdown__dropdown ul li:first-child {
  border-radius: 4px 4px 0 0;
}

.do-dropdown__dropdown__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  min-height: 42px;
}

.do-dropdown__dropdown li:hover {
  background-color: #f6f9fc;
}

.do-dropdown__dropdown__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-top: 1px solid var(--border-color);
}

.do-dropdown__dropdown__item--active {
  background: #ccc;
  color: var(--primary);
  background-color: #f6f9fc;
}

.do-dropdown__dropdown__item--add {
  border-top: 1px solid var(--border-color);
  padding: 1rem;
}

.do-dropdown__dropdown__item .btn-trans {
  font-weight: normal;
  width: 100%;
  font-size: 11px;
  transition: transform 0.25s;
}

.do-dropdown__dropdown__item .btn-trans:active {
  transform: scale(0.98);
}

.italic.font-small {
  color: #8898aa;
}

.do-dropdown__dropdown__item__actions {
  display: flex;
  align-items: center;
}

.do-dropdown__dropdown__item__actions span {
  font-style: normal;
}

/* Enter og leave-aktive styrer selve overgangen */
.do-dropdown-enter-active, .do-dropdown-leave-active {
  transition: transform 0.15s ease, opacity 0.15s ease;
}

/* Starttilstand for enter (dropdown vises) */
.do-dropdown-enter {
  opacity: 0;
  transform: scale(0.98); /* Lille skaleringsfald i starten */
}

/* Sluttilstand for enter */
.do-dropdown-enter-to {
  opacity: 1;
  transform: scale(1); /* Tilbage til normal størrelse */
}

/* Starttilstand for leave (dropdown skjules) */
.do-dropdown-leave-to {
  opacity: 0;
  transform: scale(0.98); /* Samme lille skaleringsfald ved lukning */
}

.do-dropdown__dropdown__item__name {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.do-dropdown__dropdown__item span {
  font-style: normal;
}

.do-dropdown__dropdown__item__name + .icon__bg-circle {
  opacity: 0;
}

.do-dropdown__dropdown__item:hover .do-dropdown__dropdown__item__name + .icon__bg-circle {
  opacity: 1;
}

.icon__checkmark {
  width: 30px;
  display: flex;
  height: 30px;
  align-items: center;
  justify-content: center;
}

.icon__checkmark span {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// DoEmploymentDropdown.vue?b01eb62e